<script lang="ts">
  import { AppState } from '../../etc/stores';

  const { primary200, primary500 } = $AppState.theme.colors;
</script>

<svg
  width="40"
  height="40"
  viewBox="0 0 40 40"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <circle
    opacity="0.7"
    cx="20"
    cy="20"
    r="20"
    fill="url(#paint0_linear_1298_859)"
  />
  <path
    d="M20.25 16.5V20.25M20.25 24H20.26M29.625 20.25C29.625 25.4277 25.4277 29.625 20.25 29.625C15.0723 29.625 10.875 25.4277 10.875 20.25C10.875 15.0723 15.0723 10.875 20.25 10.875C25.4277 10.875 29.625 15.0723 29.625 20.25Z"
    stroke={primary200}
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <defs>
    <linearGradient
      id="paint0_linear_1298_859"
      x1="20"
      y1="0"
      x2="20"
      y2="40"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color={primary500} />
      <stop offset="1" stop-color={primary500} stop-opacity="0" />
    </linearGradient>
  </defs>
</svg>
